import { Injectable } from "@angular/core";

@Injectable()
export class DilemaService {
  getDilemmas() {
    return [
      {
        id: 1,
        dilemmaStub: "start",
        dilemmaImg: "./assets/dilema/Dilemma1-starting-point.jpg",
        text:
          "Du er Laxmi Pariyar en dalitpige på 14, som går i 7. klasse. " +
          "Klokken er fem om morgenen og du er lige vågnet i dit lille lerhus ude på landet i Nepal.<br/>" +
          "Du har en masse lektier for, men din familie forventer, at du først laver morgenmad til hele familien og " +
          "vasker op ved pumpen bagefter. " +
          "<br/>Hvis du starter med lektierne, bliver din mor sur, men hvis du ikke laver lektier, bliver læreren sur. " +
          "<br/>Hvad gør du?",
        options: [
          {
            linkTo: "dohomework",
            optionId: 2,
            optionText: "Du laver dine lektier først.",
            optionColor: "rgb(125, 151, 124)"
          },
          {
            linkTo: "skiphomework",
            optionId: 8,
            optionText: "Du dropper lektierne og laver mad.",
            optionColor: "rgb(125, 151, 124)"
          }
        ]
      },
      {
        id: 2,
        dilemmaStub: "dohomework",
        dilemmaImg: "./assets/dilema/Dilemma1-school-Sushila.jpg",
        text:
          "Det tog lang tid, for du er ikke så god til at læse, men nu er det overstået. " +
          "Din mor bliver sur, og siger, at du er doven, så du bliver ked af det og vred. " +
          "Alligevel fletter du dit hår og tager din uniform på. " +
          "<br/>Lige før du skal gå, kommer din veninde Sushila og spørger, om du vil komme over og hjælpe hende med noget.",
        options: [
          {
            linkTo: "gotoschool",
            optionId: 3,
            optionText: "Du siger, at du ikke har tid og tager i skole."
          },
          {
            linkTo: "visitfriend",
            optionId: 12,
            optionText: "Du går med Sushila."
          }
        ]
      },
      {
        id: 3,
        dilemmaStub: "gotoschool",
        dilemmaImg: "./assets/dilema/Dilemma3-child-club.jpg",
        text:
          "Du sidder i klassen. Dine klassekammerater er alle fra højere kaster. " +
          "Du føler dig genert og anderledes. Læreren underviser i to timer, så går han, og der er ingen lærer i to timer. " +
          "<br/>En pæn dreng fra 10. klasse kommer ind og spørger, om nogen vil være med i elevrådet. " +
          "Han forklarer, at elevrådet vil gøre skolen bedre, og at børn har ret til kvalitetsundervisning. " +
          "<br/>Hvis du går med bliver din mor sur, fordi du kommer sent hjem. " +
          "<br/>Men hvis du siger ja, så kunne du måske få en bedre uddannelse, og han er ret sød ud, ham drengen." +
          "<br/>Hvad gør du?",
        options: [
          {
            linkTo: "joinclub",
            optionId: 4,
            optionText: "Du går med i elevrådet."
          },
          {
            linkTo: "dontjoinclub",
            optionId: 11,
            optionText: "Du siger ikke noget, og en anden melder sig."
          }
        ]
      },
      {
        id: 4,
        dilemmaStub: "joinclub",
        dilemmaImg: "./assets/dilema/Dilemma3AB.jpg",
        text:
          "Du gik med i elevrådet, hvor er du modig! Til det første møde fortæller den pæne dreng fra 10. klasse, " +
          "at lærerne skal være i klassen hele timen, og at de ikke må slå eleverne. " +
          "<br/>En af de andre foreslår, at I laver en kampagne for at sætte fokus på retten til kvalitetsuddannelse, men en " +
          "anden siger, at det ikke nytter noget. I beslutter at stemme om det. " +
          "<br/>Hvad stemmer du for?",
        options: [
          {
            linkTo: "makecampaign",
            optionId: 5,
            optionText:
              "Elevrådet skal lave en kampagne for børns ret til kvalitetsuddannelse."
          },
          {
            linkTo: "culturalactivities",
            optionId: 19,
            optionText:
              "Elevrådet skal bruges til at planlægge kulturelle arrangementer, som det plejer."
          }
        ]
      },
      {
        id: 5,
        dilemmaStub: "makecampaign",
        dilemmaImg: "./assets/dilema/Dilemma4A-campaigner.jpg",
        text:
          "I laver en kampagne. Du arbejder hårdt på at få kampagnen op at stå. " +
          "Du lærer en masse nyt og får nye venner. " +
          "<br/>Men din mor er ikke vild med det, du laver. Hun slår dig og beskylder dig for at flirte med den pæne dreng fra 10. " +
          "Lærerne behandler dig også værre end før. " +
          "<br/>Hvad gør du?",
        options: [
          {
            linkTo: "continuecampaign",
            optionId: 6,
            optionText:
              "Du siger til din mor, at hun ikke har lov til at slå dig og fortsætter arbejdet."
          },
          {
            linkTo: "surrender",
            optionId: 1,
            optionText: "Du giver op og stopper kampagnearbejdet."
          }
        ]
      },
      {
        id: 6,
        dilemmaStub: "continuecampaign",
        dilemmaImg: "./assets/dilema/Dilemma5A.jpg",
        text:
          "Dagen før kampagnen skal præsenteres indrømmer den pæne dreng fra 10., at han er vild med dig " +
          "og spørger, om I skal løbe bort sammen. " +
          "<br/>Hvad gør du?",
        options: [
          {
            linkTo: "tooyoung",
            optionId: 7,
            optionText:
              "Du siger til ham, at du er for ung til at løbe hjemmefra, og at kampagnen er for vigtig."
          },
          {
            linkTo: "marry",
            optionId: 1,
            optionText:
              "Du fortæller ham, at du også er vild med ham, og siger du er klar til at løbe hjemmefra."
          }
        ]
      },
      {
        id: 7,
        dilemmaStub: "tooyoung",
        dilemmaImg: "./assets/dilema/Dilemma6A.jpg",
        text:
          "I dag præsenterer du kampagnen for hele skolen. Rektor er ikke glad, og lærerne er " +
          "vrede, men forældrene og skolebestyrelsen klapper, og den nye formand for landsbyrådet ser glad ud. " +
          "<br/>Bagefter siger han til rektor, at lærerne skal gøre deres arbejde efter loven og skolebestyrelsen lover at følge op. " +
          "<br/>Du er så glad og stolt!",
        options: [
          {
            linkTo: "start",
            optionId: 1,
            optionText: "Start Forfra"
          }
        ]
      },
      {
        id: 8,
        dilemmaStub: "skiphomework",
        dilemmaImg: "./assets/dilema/Dilemma6AA.jpg",
        text:
          "Da du er færdig med at lave mad og vaske op, er der ikke tid til lektierne. Din mor siger, at du skal" +
          "gøre dig klar til skole. Lige før du går, kommer din veninde Sushila og spørger, om du kommer hen til hende. " +
          "<br/>Hvad gør du?",
        options: [
          {
            linkTo: "gotoschoolnohomework",
            optionId: 9,
            optionText: "Du siger nej til Sushila og går i skole."
          },
          {
            linkTo: "visitfriend",
            optionId: 12,
            optionText: "Du går hen til Sushila og kommer ikke i skole den dag."
          }
        ]
      },
      {
        id: 9,
        dilemmaStub: "gotoschoolnohomework",
        dilemmaImg: "./assets/dilema/Dilemma1B-angry-teacher.jpg",
        text:
          "Ha! Du gik i skole, du er bange, for du har jo ikke lavet lektier. Læreren bliver ret " +
          "sur og siger, at du lige så godt kunne være blevet hjemme, når du er så doven. Bagefter forlader hun " +
          "lokalet og er væk i flere timer, mens I sidder uden lærer. " +
          "<br/>Hvad gør du?",
        options: [
          {
            linkTo: "start",
            optionId: 1,
            optionText:
              "Du går hjem igen. Hvorfor tog du overhovedet derhen?"
          },
          {
            linkTo: "stayatclass",
            optionId: 10,
            optionText: "Du bliver i klassen og går i gang med hjemmearbejdet."
          }
        ]
      },
      {
        id: 10,
        dilemmaStub: "stayatclass",
        dilemmaImg: "./assets/dilema/Dilemma3-child-club.jpg",
        text:
          "Du blev i klassen og efter nogen tid kommer en superpæn dreng fra 10. klasse ind, og spørger om " +
          "du vil være med i elevrådet og kæmpe for alle børns ret til en ordentlig uddannelse. " +
          "<br/>Hvad gør du?",
        options: [
          {
            linkTo: "joinclub",
            optionId: 4,
            optionText:
              "Der er kun højkasteunge i elevrådet, men ham fyren ser ret godt ud, så du siger ja."
          },
          {
            linkTo: "stayinclass",
            optionId: 11,
            optionText:
              "Der bliver ballade derhjemme, hvis du siger ja, så du bliver siddende."
          }
        ]
      },
      {
        id: 11,
        dilemmaStub: "stayinclass",
        dilemmaImg: "./assets/dilema/Dilemma4B.jpg",
        text:
          "Du bliver i klassen, og i den følgende tid klarer du at dukke op i skolen de " +
          "fleste dage. Men det er sjældent, at du laver lektier. <br/>Da eksamenstiden kommer ved du, at der er stor " +
          "chance for at dumpe, og du ved også, at dine forældre ikke rigtig har råd til at betale eksamensafgiften.",
        options: [
          {
            linkTo: "takeexam",
            optionId: 21,
            optionText: "Du går til eksamen alligevel."
          },
          {
            linkTo: "factory",
            optionId: 22,
            optionText:
              "Du dropper ud af skolen og får arbejde på en fabrik sammen med din veninde Sushila."
          }
        ]
      },
      {
        id: 12,
        dilemmaStub: "visitfriend",
        dilemmaImg: "./assets/dilema/Dilemma2Btalking-factory.jpg",
        text:
          "Du går hen til Sushila og hjælper hende med hendes husarbejde. Hun fortæller dig, at hun har fået " +
          "job på den nye murstensfabrik, og hun spørger, om du kunne tænke dig at være med? " +
          "<br/>Hvis du siger ja, kan du tjene penge til din familie og så bliver de glade og holder op med at slå dig. " +
          "<br/>Men det betyder, at du skal droppe skolen. " +
          "<br/>Hvad gør du?",
        options: [
          {
            linkTo: "gotoschoolnohomework",
            optionId: 9,
            optionText: "Du siger nej, og næste dag tager du i skole."
          },
          {
            linkTo: "factory",
            optionId: 22,
            optionText: "Du dropper skolen og starter på fabrikken."
          }
        ]
      },
      {
        id: 13,
        dilemmaStub: "nowomanshouse",
        dilemmaImg: "./assets/dilema/Dilemma4B-police.jpg",
        text:
          "Du bliver hjemme og efter en tid kommer politiet til fabrikken og siger, at børn " +
          "under 18 år ikke må arbejde der. <br/>Dine forældre får en bøde, og du får besked på, at du skal tilbage til skolen. " +
          "<br/>Hvad gør du?",
        options: [
          {
            linkTo: "womanshouse",
            optionId: 14,
            optionText: "Du opsøger kvinden som tilbød dig et hjem."
          },
          {
            linkTo: "gotoschoolnohomework",
            optionId: 9,
            optionText: "Du starter i skolen igen."
          }
        ]
      },
      {
        id: 14,
        dilemmaStub: "womanshouse",
        dilemmaImg: "./assets/dilema/Dilemma3A-new-family.jpg",
        text:
          "Du flytter ind hos kvinden og hendes familie. De er supersøde. Særligt kan du godt " +
          "lide kvindens søn, som er på din alder. I bliver forelskede i hinanden, og familien synes, det er ok. " +
          "<br/>Efter nogen måneder bliver du gravid. " +
          "<br/>Hvad gør du?",
        options: [
          {
            linkTo: "motherhood",
            optionId: 15,
            optionText: "Du får barnet og bliver hos din nye familie."
          },
          {
            linkTo: "abortion",
            optionId: 16,
            optionText: "Du får en abort."
          }
        ]
      },
      {
        id: 15,
        dilemmaStub: "motherhood",
        dilemmaImg: "./assets/dilema/Dilemma3A-mother-now.jpg",
        text:
          "Du er mor nu! Du føler dig meget voksen, når du sidder med din baby. Desværre " +
          "har du mange problemer med dit underliv efter fødslen, og din kæreste er rejst til Indien for at " +
          "arbejde. Men du føler dig stadig heldig. Din svigermor er sød, og din kæreste sender penge fra " +
          "Indien, så du kan købe en mobiltelefon. <br/>" +
          "Vi forlader dig her Laxmi. Vi håber, du får et godt liv! I det mindste kan du læse og skrive, så " +
          "måske får du et bedre liv end din mor havde?<br/>" +
          "Prøv at se, hvilket liv Laxmi kunne have fået, hvis hun var blevet i skolen",
        options: [
          {
            linkTo: "start",
            optionId: 1,
            optionText: "Start forfra."
          }
        ]
      },
      {
        id: 16,
        dilemmaStub: "abortion",
        dilemmaImg: "./assets/dilema/Dilemma6AA.jpg",
        text:
          "Efter aborten har du det rigtig dårligt i lang tid. Din nye svigermor foreslår, at du tager til Qatar, et " +
          "arabisk land, og arbejder som hushjælp. Andre kvinder fra landsbyen har gjort det og tjent gode " +
          "penge. <br/>Men du har hørt, at nogle piger aldrig kommer tilbage, og at andre bliver voldtaget og slået. " +
          "<br/>Hvad gør du?",
        options: [
          {
            linkTo: "qatar",
            optionId: 17,
            optionText: "Du låner penge af din svigermor og tager afsted."
          },
          {
            linkTo: "nepal",
            optionId: 18,
            optionText: "Du bliver hjemme."
          }
        ]
      },
      {
        id: 17,
        dilemmaStub: "qatar",
        dilemmaImg: "./assets/dilema/Dilemma5B-leaving.jpg",
        text:
          "Du tager til Qatar, og det lykkedes dig at få et job hos en god familie. Du arbejder hårdt, men " +
          "det er du vant til, og nu kan du sende penge hjem. <br/>Vi vil forlade dig her. Livet er et lotteri. " +
          "<br/>Vi håber du en dag vender sikkert hjem.",
        options: [
          {
            linkTo: "start",
            optionId: 1,
            optionText: "Start forfra."
          }
        ]
      },
      {
        id: 18,
        dilemmaStub: "nepal",
        dilemmaImg: "./assets/dilema/Dilemma3A-new-family.jpg",
        text:
          "Du bliver hjemme, og efter en tid bliver du gravid igen. Denne gang beholder du barnet. Dit " +
          "helbred er ikke det bedste, men du klarer dig. Du bliver medlem af en kvindegruppe, hvor du kan " +
          "låne penge til en ged. Du planlægger, at du skal købe en til, når du har betalt for den første. " +
          "<br/>Vi siger farvel til dig her. Livet er ikke let, men du har en chance. <br/>Held og lykke!",
        options: [
          {
            linkTo: "start",
            optionId: 1,
            optionText: "Start forfra."
          }
        ]
      },
      {
        id: 19,
        dilemmaStub: "culturalactivities",
        dilemmaImg: "./assets/dilema/Dilemma7B-childs-club.jpg",
        text:
          "Du stemte for, at elevrådet kun skal stå for kulturelle aktiviteter. Det kan lærerne godt lide. Du lærer " +
          "stadig for lidt, og lærerne dukker ikke altid op til timerne, men du får lidt bedre karakterer, og " +
          "lærerne er lidt sødere. <br/>Men du kan se, hvordan flere og flere fattige, som dig selv stopper i skolen, " +
          "fordi de ikke kan følge med. " +
          "<br/>Hvad gør du?",
        options: [
          {
            linkTo: "encouragefriendsclub",
            optionId: 20,
            optionText:
              "Du opfordrer de fattige børn til også at blive medlem af elevrået. Særligt pigerne."
          },
          {
            linkTo: "happy",
            optionId: 21,
            optionText:
              "Du ryster på hovedet og føler dig glad, fordi du ikke længere er som dem."
          }
        ]
      },
      {
        id: 20,
        dilemmaStub: "encouragefriendsclub",
        dilemmaImg: "./assets/dilema/Dilemma7A-child-club.jpg",
        text:
          "Nogen af de andre fattige børn er startet i elevrådet. De var blevet spurgt før, men nu hvor du er " +
          "med, føler de sig mere trygge. Lederen af elevrådet, den pæne dreng, foreslår igen, at I laver en " +
          "kampagne for at gøre skolen bedre. <br/>Du beslutter, at sige ja, for du kan godt se, at det er det eneste " +
          "rigtige at gøre.",
        options: [
          {
            linkTo: "makecampaign",
            optionId: 5,
            optionText: "Fortsæt."
          }
        ]
      },
      {
        id: 21,
        dilemmaStub: "happy",
        dilemmaImg: "./assets/dilema/Dilemma7B-congratiolations.jpg",
        text:
          "Tillykke! Du klarede 10. klasse. Du fortsætter ikke i 11. klasse selvom det er vigtigt, " +
          "hvis du skal have en videregående uddannelse. Det ville dine forældre alligevel aldrig få råd til. " +
          "<br/>Men du er bedre udstyret til at klare livet end dine forældre var, og du kender dine rettigheder. " +
          "<br/>Vi ønsker dig det allerbedste for fremtiden!",
        options: [
          {
            linkTo: "start",
            optionId: 1,
            optionText: "Start forfra."
          }
        ]
      },
      {
        id: 22,
        dilemmaStub: "factory",
        dilemmaImg: "./assets/dilema/Dilemma3B-at-factory.jpg",
        text:
          "Du har et job nu! Dine forældre er ikke vilde med det i starten, men nu tjener " +
          "du penge, og det har de brug for. På fabrikken får du nye veninder, en kvinde inviterer dig til at " +
          "komme og bo hos sig. Hun siger, at hun har en sød søn, som du kunne blive venner med. " +
          "<br/>Hvis du siger ja, så er du fri for dine forældres evige brokkeri, og kvinden er virkelig rar.",
        options: [
          {
            linkTo: "womanshouse",
            optionId: 14,
            optionText: "Du flytter til kvindens hus."
          },
          {
            linkTo: "nowomanshouse",
            optionId: 13,
            optionText:
              "Du fortæller kvinden, at du ikke er klar til at flytte hjemmefra."
          }
        ]
      }
    ];
  }
}
